import TraceReportDetails from '@/components/Reports/TraceReportDetails';
import { ReportSearch } from '@/models';
import { TraceReportViewModel } from '@/viewModels';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: { TraceReportDetails }
})
export default class TraceReports extends Vue {
  public viewModel = new TraceReportViewModel();
  public command = new ReportSearch();
  public pagination: any = {};
  public get reports() {
    return this.$store.getters.reports;
  }
  public get isDialogOpen() {
    return this.$store.getters.dialogOpen;
  }
  public get busy() {
    return this.$store.getters.isBusy;
  }
  public get ngbids() {
    return this.$dataService.ngbids();
  }
  public updateStatus(model) {
    this.$api.getStatus(model.requestId);
  }
  public search() {
    const { sortBy, descending, page, rowsPerPage } = this.pagination;
    if (page) {
      this.command.pageNumber = page > 0 ? page - 1 : page;
    }
    if (rowsPerPage) {
      this.command.pageSize = rowsPerPage;
    }
    this.$api.searchReport(this.command).then(x => {});
  }
  @Watch('pagination') onPageChanged(o, n) {
    console.log('changed', o);
    this.search();
  }
  mounted() {
    // this.command.ngbid = 5;
    this.search();
  }
  public viewDetails(model) {
    this.$api.retrieveReport(model.requestId);
    this.setDialogState(true);
  }
  public get datasets() {
    return this.$store.getters.dataSets;
  }
  public closeDialog() {
    this.setDialogState(false);
  }

  private setDialogState(isOpen: boolean) {
    this.$dataService.setDialogState(isOpen);
  }
}
